const SET_SELECTED_JOURNAL = (state, payload) => {
  state.selectedJournal = payload.origin.journalById;
};

export default SET_SELECTED_JOURNAL;
